export default "__VITE_ASSET__K1vcYUtD__"